/**
 * @fileoverview gRPC-Web generated client stub for deal_transporter_direction_note
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.21.12
// source: protobuf/deal_transporter_direction_note/deal_transporter_direction_note.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb from '../../protobuf/deal_transporter_direction_note/deal_transporter_direction_note_pb';
import * as protobuf_model_merged_pb from '../../protobuf/model/merged_pb';


export class DealTransporterDirectionNoteServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'binary';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorCreate = new grpcWeb.MethodDescriptor(
    '/deal_transporter_direction_note.DealTransporterDirectionNoteService/Create',
    grpcWeb.MethodType.UNARY,
    protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.CreateDealTransporterDirectionNoteRequest,
    protobuf_model_merged_pb.DealTransporterDirectionNoteResponse,
    (request: protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.CreateDealTransporterDirectionNoteRequest) => {
      return request.serializeBinary();
    },
    protobuf_model_merged_pb.DealTransporterDirectionNoteResponse.deserializeBinary
  );

  create(
    request: protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.CreateDealTransporterDirectionNoteRequest,
    metadata: grpcWeb.Metadata | null): Promise<protobuf_model_merged_pb.DealTransporterDirectionNoteResponse>;

  create(
    request: protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.CreateDealTransporterDirectionNoteRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: protobuf_model_merged_pb.DealTransporterDirectionNoteResponse) => void): grpcWeb.ClientReadableStream<protobuf_model_merged_pb.DealTransporterDirectionNoteResponse>;

  create(
    request: protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.CreateDealTransporterDirectionNoteRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: protobuf_model_merged_pb.DealTransporterDirectionNoteResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/deal_transporter_direction_note.DealTransporterDirectionNoteService/Create',
        request,
        metadata || {},
        this.methodDescriptorCreate,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/deal_transporter_direction_note.DealTransporterDirectionNoteService/Create',
    request,
    metadata || {},
    this.methodDescriptorCreate);
  }

  methodDescriptorUpdate = new grpcWeb.MethodDescriptor(
    '/deal_transporter_direction_note.DealTransporterDirectionNoteService/Update',
    grpcWeb.MethodType.UNARY,
    protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.UpdateDealTransporterDirectionNoteRequest,
    protobuf_model_merged_pb.DealTransporterDirectionNoteResponse,
    (request: protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.UpdateDealTransporterDirectionNoteRequest) => {
      return request.serializeBinary();
    },
    protobuf_model_merged_pb.DealTransporterDirectionNoteResponse.deserializeBinary
  );

  update(
    request: protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.UpdateDealTransporterDirectionNoteRequest,
    metadata: grpcWeb.Metadata | null): Promise<protobuf_model_merged_pb.DealTransporterDirectionNoteResponse>;

  update(
    request: protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.UpdateDealTransporterDirectionNoteRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: protobuf_model_merged_pb.DealTransporterDirectionNoteResponse) => void): grpcWeb.ClientReadableStream<protobuf_model_merged_pb.DealTransporterDirectionNoteResponse>;

  update(
    request: protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.UpdateDealTransporterDirectionNoteRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: protobuf_model_merged_pb.DealTransporterDirectionNoteResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/deal_transporter_direction_note.DealTransporterDirectionNoteService/Update',
        request,
        metadata || {},
        this.methodDescriptorUpdate,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/deal_transporter_direction_note.DealTransporterDirectionNoteService/Update',
    request,
    metadata || {},
    this.methodDescriptorUpdate);
  }

  methodDescriptorGet = new grpcWeb.MethodDescriptor(
    '/deal_transporter_direction_note.DealTransporterDirectionNoteService/Get',
    grpcWeb.MethodType.UNARY,
    protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.GetDealTransporterDirectionNotesRequest,
    protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.GetDealTransporterDirectionNotesResponse,
    (request: protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.GetDealTransporterDirectionNotesRequest) => {
      return request.serializeBinary();
    },
    protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.GetDealTransporterDirectionNotesResponse.deserializeBinary
  );

  get(
    request: protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.GetDealTransporterDirectionNotesRequest,
    metadata: grpcWeb.Metadata | null): Promise<protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.GetDealTransporterDirectionNotesResponse>;

  get(
    request: protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.GetDealTransporterDirectionNotesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.GetDealTransporterDirectionNotesResponse) => void): grpcWeb.ClientReadableStream<protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.GetDealTransporterDirectionNotesResponse>;

  get(
    request: protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.GetDealTransporterDirectionNotesRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.GetDealTransporterDirectionNotesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/deal_transporter_direction_note.DealTransporterDirectionNoteService/Get',
        request,
        metadata || {},
        this.methodDescriptorGet,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/deal_transporter_direction_note.DealTransporterDirectionNoteService/Get',
    request,
    metadata || {},
    this.methodDescriptorGet);
  }

  methodDescriptorDelete = new grpcWeb.MethodDescriptor(
    '/deal_transporter_direction_note.DealTransporterDirectionNoteService/Delete',
    grpcWeb.MethodType.UNARY,
    protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.DeleteDealTransporterDirectionNotesRequest,
    protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.DeleteDealTransporterDirectionNotesResponse,
    (request: protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.DeleteDealTransporterDirectionNotesRequest) => {
      return request.serializeBinary();
    },
    protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.DeleteDealTransporterDirectionNotesResponse.deserializeBinary
  );

  delete(
    request: protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.DeleteDealTransporterDirectionNotesRequest,
    metadata: grpcWeb.Metadata | null): Promise<protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.DeleteDealTransporterDirectionNotesResponse>;

  delete(
    request: protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.DeleteDealTransporterDirectionNotesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.DeleteDealTransporterDirectionNotesResponse) => void): grpcWeb.ClientReadableStream<protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.DeleteDealTransporterDirectionNotesResponse>;

  delete(
    request: protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.DeleteDealTransporterDirectionNotesRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.DeleteDealTransporterDirectionNotesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/deal_transporter_direction_note.DealTransporterDirectionNoteService/Delete',
        request,
        metadata || {},
        this.methodDescriptorDelete,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/deal_transporter_direction_note.DealTransporterDirectionNoteService/Delete',
    request,
    metadata || {},
    this.methodDescriptorDelete);
  }

  methodDescriptorList = new grpcWeb.MethodDescriptor(
    '/deal_transporter_direction_note.DealTransporterDirectionNoteService/List',
    grpcWeb.MethodType.UNARY,
    protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.ListDealTransporterDirectionNotesRequest,
    protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.ListDealTransporterDirectionNotesResponse,
    (request: protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.ListDealTransporterDirectionNotesRequest) => {
      return request.serializeBinary();
    },
    protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.ListDealTransporterDirectionNotesResponse.deserializeBinary
  );

  list(
    request: protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.ListDealTransporterDirectionNotesRequest,
    metadata: grpcWeb.Metadata | null): Promise<protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.ListDealTransporterDirectionNotesResponse>;

  list(
    request: protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.ListDealTransporterDirectionNotesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.ListDealTransporterDirectionNotesResponse) => void): grpcWeb.ClientReadableStream<protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.ListDealTransporterDirectionNotesResponse>;

  list(
    request: protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.ListDealTransporterDirectionNotesRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.ListDealTransporterDirectionNotesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/deal_transporter_direction_note.DealTransporterDirectionNoteService/List',
        request,
        metadata || {},
        this.methodDescriptorList,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/deal_transporter_direction_note.DealTransporterDirectionNoteService/List',
    request,
    metadata || {},
    this.methodDescriptorList);
  }

  methodDescriptorExport = new grpcWeb.MethodDescriptor(
    '/deal_transporter_direction_note.DealTransporterDirectionNoteService/Export',
    grpcWeb.MethodType.UNARY,
    protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.ExportDealTransporterDirectionNotesRequest,
    protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.ExportDealTransporterDirectionNotesResponse,
    (request: protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.ExportDealTransporterDirectionNotesRequest) => {
      return request.serializeBinary();
    },
    protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.ExportDealTransporterDirectionNotesResponse.deserializeBinary
  );

  export(
    request: protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.ExportDealTransporterDirectionNotesRequest,
    metadata: grpcWeb.Metadata | null): Promise<protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.ExportDealTransporterDirectionNotesResponse>;

  export(
    request: protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.ExportDealTransporterDirectionNotesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.ExportDealTransporterDirectionNotesResponse) => void): grpcWeb.ClientReadableStream<protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.ExportDealTransporterDirectionNotesResponse>;

  export(
    request: protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.ExportDealTransporterDirectionNotesRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: protobuf_deal_transporter_direction_note_deal_transporter_direction_note_pb.ExportDealTransporterDirectionNotesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/deal_transporter_direction_note.DealTransporterDirectionNoteService/Export',
        request,
        metadata || {},
        this.methodDescriptorExport,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/deal_transporter_direction_note.DealTransporterDirectionNoteService/Export',
    request,
    metadata || {},
    this.methodDescriptorExport);
  }

}

